import React, { useEffect, useState } from 'react';
import style from '../../css/Carousel.module.css';
import { FaAngleLeft, FaAngleRight, FaCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function Carousel({ data }) {
	const [currentIndex, setCurrentIndex] = useState(0);
	const [isHovered, setIsHovered] = useState(false);

	const nextSlide = () => {
		setCurrentIndex((prevIndex) =>
			prevIndex === data.length - 1 ? 0 : prevIndex + 1
		);
	};

	const prevSlide = () => {
		setCurrentIndex((prevIndex) =>
			prevIndex === 0 ? data.length - 1 : prevIndex - 1
		);
	};

	const handleMouseEnter = () => {
		setIsHovered(true);
	};

	const handleMouseLeave = () => {
		setIsHovered(false);
	};

	useEffect(() => {
		let interval;

		if (!isHovered) {
			interval = setInterval(() => {
				nextSlide();
			}, 4000);
		}

		return () => clearInterval(interval);
	}, [isHovered, nextSlide]);

	return (
		<div
			className={style.carousel}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			{data.map((item, index) => (
				<div
					className={`${style.container} ${
						index === currentIndex ? style.active : ''
					}`}
					key={item.id}
				>
					<img
						src={item.image}
						alt="carousel-pic"
						className={style.carousel_pic}
					/>
					<div className={style.txtCon}>
						<h2 className={style.txt1}>{item.headertxt}</h2>
						<p className={style.txt2}>{item.para}</p>

						<Link className={style.btn} to={item.navi}>
							<p>{item.btntxt}</p>
							<FaAngleRight />
						</Link>
					</div>
				</div>
			))}

			<div className={style.circleButtons}>
				{data.map((_, index) => (
					<div
						key={index}
						className={currentIndex === index ? style.btn_c_a : style.btn_c}
						onClick={() => setCurrentIndex(index)}
					/>
				))}
			</div>
			<p onClick={prevSlide}>
				<FaAngleRight className={style.prevButton} />
			</p>
			<p onClick={nextSlide}>
				<FaAngleLeft className={style.nextButton} />
			</p>
		</div>
	);
}

export default Carousel;
